import * as Animate from "react-reveal";
import { podcastData } from "../podcastData";

const GLOW_BAR_HEIGHTS = [16, 34, 22, 46, 28, 40, 18, 36, 24, 44, 20, 32];

const PodcastFeaturedSection = () => {
  const featured =
    podcastData.find((episode) => episode.featured) || podcastData[0];

  return (
    <section
      aria-labelledby="podcast-featured-heading"
      className="mx-auto px-[18px] sm:px-[26px] pt-8 pb-[54px] lg:pb-[74px]"
      style={{ maxWidth: "1280px" }}
    >
      <Animate.Fade bottom>
        <div className="podcast-grid-featured gap-[34px] lg:gap-[64px] items-center">
          <div
            className="podcast-featured-media relative overflow-hidden"
            style={{
              background:
                "linear-gradient(160deg, #050794 0%, #030360 60%, #010128 100%)",
            }}
          >
            <img
              src={featured.image}
              alt={`${featured.name}, ${featured.role}`}
              className="w-full h-full object-cover"
            />
            <div
              className="absolute inset-0 pointer-events-none"
              style={{
                background:
                  "linear-gradient(120deg, rgba(3,4,95,0.55) 0%, rgba(3,4,95,0) 35%, rgba(3,4,95,0) 62%, rgba(251,175,27,0.16) 85%, rgba(251,175,27,0.3) 100%)",
              }}
              aria-hidden="true"
            />
            <div
              className="absolute inset-x-0 bottom-0 pointer-events-none"
              style={{
                top: "62%",
                background: "linear-gradient(transparent, rgba(1,1,40,0.75))",
              }}
              aria-hidden="true"
            />
            <div
              className="podcast-featured-waveform absolute flex items-end"
              aria-hidden="true"
            >
              {GLOW_BAR_HEIGHTS.map((h, i) => (
                <span
                  key={i}
                  className="podcast-waveform-bar rounded-full bg-secondary inline-block shrink-0"
                  style={{ height: `${h}px`, opacity: 0.35 + (h / 46) * 0.65 }}
                />
              ))}
            </div>
            <span className="podcast-featured-badge absolute inline-flex items-center bg-secondary text-primary tracking-[0.06em] text-[13px] font-extrabold">
              FEATURED SPEAKER
            </span>
          </div>

          <div>
            <p className="text-[#9a6500] tracking-[0.1em] text-[14px] font-extrabold leading-[1.45] mb-4 uppercase">
              {featured.category}
            </p>
            <h2
              id="podcast-featured-heading"
              className="text-primary tracking-[-0.04em] leading-[1.14] font-bold mb-6"
              style={{ fontSize: "clamp(32px, 3.6vw, 48px)" }}
            >
              {featured.title}
            </h2>
            <p className="flex items-center gap-3 mb-5">
              <span className="text-[#101223] font-extrabold text-[17px]">
                {featured.name}
              </span>
              <span className="w-px h-[18px] bg-secondary inline-block shrink-0" />
              <span className="text-[#555b6e] text-[16px]">
                {featured.role}
              </span>
            </p>
            <p className="text-[#555b6e] max-w-[560px] text-[17px] leading-[1.78] mb-8">
              {featured.description}
            </p>
            <a
              href={featured.linkUrl}
              target="_blank"
              rel="noreferrer"
              className="bg-primary text-white rounded-2xl inline-flex items-center gap-3 text-[15px] font-bold pl-3 pr-6 hover:bg-[#03045f] hover:-translate-y-0.5 transition-all"
              style={{ minHeight: "56px" }}
            >
              <span className="podcast-play-dot inline-flex items-center justify-center rounded-full bg-secondary shrink-0">
                <span aria-hidden="true" className="podcast-play-triangle" />
              </span>
              Play featured episode
            </a>
          </div>
        </div>
      </Animate.Fade>
    </section>
  );
};

export default PodcastFeaturedSection;
